// extracted by mini-css-extract-plugin
export default {"section":"Tables_section__6DwdI","noTableSection":"Tables_noTableSection__Om2qZ"};